import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className='min-h-screen bg-[#F1F1E9] flex flex-col items-center justify-center gap-6 p-8'>
            <div className='text-center space-y-4'>
              <h1
                className='text-2xl font-semibold text-gray-800'
                style={{ fontFamily: 'AngieSansStd' }}
              >
                Oops! Something went wrong
              </h1>
              <p
                className='text-gray-600 max-w-md'
                style={{ fontFamily: 'Figtree' }}
              >
                We're sorry, but something unexpected happened. Please try
                refreshing the page.
              </p>
              <button
                onClick={() => window.location.reload()}
                className='px-6 py-3 bg-[#C18E10] text-white rounded-full hover:bg-[#A67A0E] transition-colors font-medium'
                style={{ fontFamily: 'Figtree' }}
              >
                Refresh Page
              </button>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
